<template>
  <div class="catalogButtonPanel">
    <div class="catalogButtonPanel__buttons">
      <ActionButton
          class="catalogButtonPanel__button"
          v-for="page in Pages"
          :key="page.id"
      >
        <template #caption>
          <span class="catalogButtonPanel__buttonCaption">
            {{page.name}}
          </span>
        </template>
      </ActionButton>
    </div>
    <div class="catalogButtonPanel__filter">
        <VDropdown
          data-popper-placement="bottom"
        >
          <ActionButton class="catalogButtonPanel__dropdownButton">
            <template #caption>
            <div class="catalogButtonPanel__dropdownSortContent">
              Популярные
              <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.85693 1.35501L6.85693 6.35501L11.8569 1.35501" stroke="white"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            </template>
          </ActionButton>
          <template #popper>
             Test
          </template>
        </VDropdown>

      <ActionButton class="catalogButtonPanel__dropdownButton">
        <template #caption>
          <div class="catalogButtonPanel__dropdownFindContent">
            Введите название товара
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 19.4979C15.4183 19.4979 19 15.9161 19 11.4979C19 7.07959 15.4183 3.49786 11 3.49786C6.58172 3.49786 3 7.07959 3 11.4979C3 15.9161 6.58172 19.4979 11 19.4979Z" stroke="white" stroke-opacity="0.77" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M20.9999 21.4979L16.6499 17.1479" stroke="white" stroke-opacity="0.77" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>


          </div>
        </template>
      </ActionButton>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/ui/ActionButton.vue";
import {reactive} from "vue";

export default {
  name: "CatalogButtonPanel",
  components: {ActionButton},
  setup() {
    const Pages = reactive([
      {id: 1, name: 'Все'},
      {id: 2, name: 'Семинары'},
      {id: 3, name: 'Мерч'},
      {id: 4, name: 'Монеты'},
    ]);
    return {Pages}
  }
}
</script>



<style scoped lang="scss">
.catalogButtonPanel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 0;
  gap: 5px;
  &__buttons {
    display: flex;
    gap: 10px;
  }
  &__buttonCaption {
    padding: 0 5px;
  }

&__button {
  border-radius: 8px;
}
&__dropdownButton {
  border-radius: 20px;
}
&__dropdownSortContent {
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  opacity: 50%;
  min-width: 200px;
  svg {
    width: 16px;
    height: 16px;
  }
}
 &__dropdownFindContent {
   padding: 0 10px;
   display: flex;
   justify-content: space-between;
   opacity: 50%;
   min-width: 440px;
   svg {
     width: 16px;
     height: 16px;
   }
 }
  &__filter {
    display: flex;
    gap: 10px;
  }
}
</style>
